import { Link } from 'react-router-dom';

interface RelatedArticle {
  slug: string;
  title: string;
  imageUrl: string;
  categoryName: string;
  date: string;
  readTime: string;
}

interface RelatedArticlesProps {
  articles: RelatedArticle[];
}

export default function RelatedArticles({ articles }: RelatedArticlesProps) {
  if (articles.length === 0) return null;

  return (
    <div className="mt-10">
      <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-5">
        相关文章推荐
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {articles.map((article) => (
          <Link
            key={article.slug}
            to={`/article/${article.slug}`}
            className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer flex flex-col"
          >
            <div className="relative h-36 overflow-hidden">
              <img
                src={article.imageUrl}
                alt={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4 flex-1 flex flex-col">
              <span className="text-xs text-accent-600 font-medium bg-accent-100 px-2 py-0.5 rounded-md self-start mb-2">
                {article.categoryName}
              </span>
              <h4 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                {article.title}
              </h4>
              <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/70 mt-auto">
                <span className="text-xs text-foreground-400">{article.date}</span>
                <span className="text-xs text-foreground-400">{article.readTime}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}